// Feature flags, set at build time. Everything new is off unless enabled.

// Guest messaging: visitors can message an instructor with only name, email
// and message. Must match GUEST_MESSAGING_ENABLED on the backend.
export const GUEST_MESSAGING_ENABLED =
    process.env.REACT_APP_GUEST_MESSAGING === "true";

// Cloudflare Turnstile site key (public).
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";

// Quick booking: visitors book with name, email and phone (4-digit SMS code)
// instead of the sign-up form. The backend endpoints come with guest
// messaging (GUEST_MESSAGING_ENABLED).
export const GUEST_BOOKING_ENABLED =
    process.env.REACT_APP_GUEST_BOOKING === "true";

// Booking popup on the instructor page: date/time selection, checkout, phone
// confirmation and the request all happen in one popup instead of separate
// pages. Guests need REACT_APP_GUEST_BOOKING as well.
export const BOOKING_POPUP_ENABLED =
    process.env.REACT_APP_BOOKING_POPUP === "true";

// Stripe publishable key (public). Lets new students enter their card before
// they have an account. Must belong to the same Stripe account as the backend.
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
